import { Controller } from 'stimulus';
import MitreTable from '../utils/mitre-table';


class TableAdSponsorRowController extends Controller {
  tableIdentifier = "m-table";
  tableApiIdentifier = "t";

  initialize() {
    const tableKey = this.element.closest('[data-table-key-value]').getAttribute('data-table-key-value');
    this._mitreTable = MitreTable.getByTableKey(tableKey);

    if(this.element.dataset['tableIdentifier']) {
      this.tableIdentifier = this.element.dataset['tableIdentifier'];
    }

    if(this.element.dataset['tableApiIdentifier']) {
      this.tableApiIdentifier = this.element.dataset['tableApiIdentifier'];
    }
  }

  connect() {
    this._handleTableSponsorRowUpdateTableBodyUpdate = (adUnitName) => this._triggerSponsoredRowUpdate(adUnitName);

    EventManager.onNewEvent('table-sponsor-row-update-after-table-body-update', this._handleTableSponsorRowUpdateTableBodyUpdate);

    this._triggerSponsoredRowUpdate();
  }

  disconnect() {
    EventManager.off('table-sponsor-row-update-after-table-body-update', this._handleTableSponsorRowUpdateTableBodyUpdate)
  }

  _triggerSponsoredRowUpdate(adUnitName) {
    const adPositionElement = this.element.closest('[data-controller*="ad-position"]');
    const adUnit = adPositionElement?.getAttribute('data-ad-position-id');
    const currentAdUnitName = adUnit?.split('/').pop();

    if (adUnitName && adUnitName !== currentAdUnitName) {
      return null;
    }

    this._mitreTable.emit('table-sponsor-row-update', ({
      symbol: this.element.getAttribute('data-symbol'),
      securityType: this.element.getAttribute('data-security-type'),
      link: this.element.getAttribute('data-link'),
      target: this.element.getAttribute('data-link-target'),
      hasDisclaimer: this.element.getAttribute('data-has-disclaimer'),
      hasDisclosure: this.element.getAttribute('data-has-disclosure'),
      disclaimerLogo:  this.element.getAttribute('data-disclaimer-logo'),
      disclaimerTitle:  this.element.getAttribute('data-disclaimer-title'),
      disclaimerText:  this.element.getAttribute('data-disclaimer-text'),
      enableDisclaimerHover:  this.element.getAttribute('data-enable-disclaimer-hover'),
      adUnit: currentAdUnitName,
      hideSponsoredTag: this.element.getAttribute('data-hide-sponsored-tag')
    }));
  }
}

export default TableAdSponsorRowController;
